import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

function Opt({ k, f, setF, label, testid }) {
  return (
    <label className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-3 text-sm cursor-pointer">
      <input type="checkbox" data-testid={testid} checked={!!f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} className="mt-0.5 w-5 h-5 accent-brand-navy" />
      <span>{label}</span>
    </label>
  );
}

export default function ConfirmSignup() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [f, setF] = useState({ privacy_accepted: false, marketing_consent: false, profiling_consent: false });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    api.get(`/auth/invite/${encodeURIComponent(token)}`)
      .then((r) => { setInfo(r.data); setF({ privacy_accepted: false, marketing_consent: r.data.marketing_consent, profiling_consent: r.data.profiling_consent }); })
      .catch((e) => setInfo({ error: errMsg(e) }));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/auth/invite/${encodeURIComponent(token)}`, f);
      toast.success("Iscrizione confermata! Accedi con la password temporanea dell'email");
      navigate(`/accedi?email=${encodeURIComponent(data.email)}&confermato=1`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (!info) return <div className="py-24 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  if (info.error)
    return (
      <div className="max-w-xl mx-auto px-4 py-20 space-y-4" data-testid="confirm-signup-error">
        <h1 className="text-4xl font-extrabold uppercase text-brand-navy">Link non valido</h1>
        <p className="text-slate-700">{info.error}</p>
        <Link to="/accedi" className="press inline-flex h-11 px-5 items-center rounded-md bg-brand-navy text-white font-semibold">Vai all'accesso</Link>
      </div>
    );
  return (
    <div className="max-w-xl mx-auto px-4 py-14 space-y-6" data-testid="confirm-signup">
      <div>
        <div className="font-mono text-[11px] tracking-widest text-slate-500">CONFERMA ISCRIZIONE</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold uppercase text-brand-navy">Ciao {info.name}</h1>
        <p className="text-slate-700 mt-2">Il negozio ha registrato i tuoi dati con l'email <b data-testid="confirm-signup-email">{info.email}</b>{info.company && <> per <b>{info.company}</b></>}. Controlla le tue scelte sulla privacy, modificale se vuoi e conferma per attivare l'account.</p>
      </div>
      <form onSubmit={submit} className="space-y-3">
        <Opt k="privacy_accepted" f={f} setF={setF} testid="confirm-privacy"
          label={<>Ho letto l'<Link to="/privacy" target="_blank" className="underline font-semibold">informativa privacy</Link> e acconsento al trattamento dei dati per gestire account e ordini <b>(obbligatorio)</b></>} />
        <Opt k="marketing_consent" f={f} setF={setF} testid="confirm-marketing" label="Voglio ricevere comunicazioni commerciali e offerte (facoltativo)" />
        <Opt k="profiling_consent" f={f} setF={setF} testid="confirm-profiling" label="Voglio ricevere offerte personalizzate in base ai miei acquisti (facoltativo)" />
        <button data-testid="confirm-signup-submit" disabled={busy || !f.privacy_accepted} className="press w-full h-12 rounded-md bg-brand-yellow text-brand-navy font-semibold flex items-center justify-center gap-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-5 h-5" />} Conferma iscrizione
        </button>
        <p className="text-xs text-slate-500">Dopo la conferma accedi con la password temporanea che trovi nell'email: ti chiederemo subito di sceglierne una nuova. Puoi cambiare i consensi quando vuoi dal tuo account.</p>
      </form>
    </div>
  );
}
